import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon, EyeOffIcon, LockIcon, UserIcon } from 'lucide-react';
const LoginScreen = ({
  onLogin
}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = e => {
    e.preventDefault();
    // Basic validation
    if (username && password) {
      // Call the onLogin function passed from App component
      onLogin();
      // Navigate is not needed here as the App component will redirect
      // based on isAuthenticated state, but we'll keep it as a fallback
      navigate('/');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" data-id="element-457">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md" data-id="element-458">
        <div className="flex flex-col items-center mb-8" data-id="element-459">
          <div className="w-20 h-20 rounded-full bg-blue-800 flex items-center justify-center mb-4" data-id="element-460">
            <span className="text-white text-2xl font-bold" data-id="element-461">BG</span>
          </div>
          <h1 className="text-2xl font-bold text-center text-gray-800" data-id="element-462">
            Burhani Guards
          </h1>
          <h2 className="text-lg text-center text-gray-600" data-id="element-463">
            Dahod Admin Portal
          </h2>
        </div>
        <form onSubmit={handleLogin} data-id="element-464">
          <div className="mb-6" data-id="element-465">
            <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-466">
              Username
            </label>
            <div className="relative" data-id="element-467">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-468">
                <UserIcon size={18} className="text-gray-500" data-id="element-469" />
              </div>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your username" required data-id="element-470" />
            </div>
          </div>
          <div className="mb-6" data-id="element-471">
            <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-472">
              Password
            </label>
            <div className="relative" data-id="element-473">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-474">
                <LockIcon size={18} className="text-gray-500" data-id="element-475" />
              </div>
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your password" required data-id="element-476" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-477">
                {showPassword ? <EyeOffIcon size={18} className="text-gray-500" data-id="element-478" /> : <EyeIcon size={18} className="text-gray-500" data-id="element-479" />}
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between mb-6" data-id="element-480">
            <div className="flex items-center" data-id="element-481">
              <input id="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-482" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-483">
                Remember me
              </label>
            </div>
            <a href="#" className="text-sm text-blue-600 hover:underline" data-id="element-484">
              Forgot password?
            </a>
          </div>
          <button type="submit" className="w-full py-2 px-4 bg-blue-800 hover:bg-blue-700 text-white font-medium rounded-md transition duration-200" data-id="element-485">
            Sign In
          </button>
        </form>
        <div className="mt-8 text-center text-sm text-gray-600" data-id="element-486">
          <p data-id="element-487">© 2023 Burhani Guards Dahod. All rights reserved.</p>
        </div>
      </div>
    </div>;
};
export default LoginScreen;